import { type NgOverlayContainerConfiguration } from 'ng-overlay-container';

export const DEFAULT_FORM_CLOSE_OVERLAY_CONFIGURATION: Partial<NgOverlayContainerConfiguration> = {
    useGlobalPositionStrategy: true,
    height: '224px',
    panelClass: 'form-close-modal-panel',
    backdropClass: 'cdk-overlay-dark-backdrop',
    isResizable: false,
};
